import React, { useEffect, useState } from "react";
import styles from "./DocumentTypeSelector.module.css";

const DOCUMENT_TYPES = [
  { value: "income_draft", label: "수입기안" },
  { value: "expense_draft", label: "지출기안" },
  { value: "income_resolution", label: "수입결의" },
  { value: "expense_resolution", label: "지출결의" },
];

// 📂 문서 종류별 카테고리 매핑
const CATEGORY_OPTIONS = {
  income_draft: [
    { value: "경영팀", label: "경영팀" },
    { value: "용역사업", label: "용역" },
    { value: "환경/소독", label: "소독" },
    { value: "환경/종합", label: "종합" },
  ],
  expense_draft: [
    { value: "경영팀", label: "경영팀" },
    { value: "용역사업", label: "용역" },
    { value: "환경/소독", label: "소독" },
    { value: "환경/종합", label: "종합" },
    { value: "CAFE_INN_가산", label: "가산" },
    { value: "CAFE_INN_독산", label: "독산" },
    { value: "CAFE_INN_금나래", label: "금나래" },
    { value: "CAFE_INN_그린", label: "그린" },
    { value: "테스트", label: "테스트" },
  ],
  income_resolution: [
    { value: "경영팀", label: "경영팀" },
    { value: "용역사업", label: "용역" },
    { value: "환경/소독", label: "소독" },
    { value: "환경/종합", label: "종합" },
  ],
  expense_resolution: [
    { value: "경영팀", label: "경영팀" },
    { value: "용역사업", label: "용역" },
    { value: "환경/소독", label: "소독" },
    { value: "환경/종합", label: "종합" },
  ],
};

// 📂 문서종류-카테고리별 세부 옵션 매핑
const DETAIL_OPTIONS = {
  "income_draft-경영팀": [
    { value: "수입보고", label: "수입보고" }
  ],
  "income_draft-용역사업": [
    { value: "기성계", label: "기성계" },
    { value: "완수계", label: "완수계" },
    { value: "준공계", label: "준공계" }
  ],
  "income_draft-환경/소독": [
    { value: "대금청구", label: "대금청구" },
    { value: "기성계", label: "기성계" },
    { value: "완수계", label: "완수계" },
    { value: "준공계", label: "준공계" }
  ],
  "income_draft-환경/종합": [
    { value: "대금청구", label: "대금청구" },
    { value: "개인고객 대금청구", label: "개인고객 대금청구" },
    { value: "기성계", label: "기성계" },
    { value: "완수계", label: "완수계" },
    { value: "준공계", label: "준공계" }
  ],

  // ✅ 지출 경영팀 — value가 곧 templateCode
  "expense_draft-경영팀": [
    { value: "meeting_expense", label: "간담회비" },
    { value: "service_contract", label: "계약인지세" },
    { value: "deduction_refund", label: "공제금환급" },
    { value: "meal_allowance", label: "급량비" },
    { value: "donation", label: "기부금" },
    { value: "accounting_fee", label: "기장수수료" },
    { value: "general_purchase", label: "물품구매" },
    { value: "banner_ad", label: "배너광고" },
    { value: "corporate_seal", label: "법인인감증명서" },
    { value: "fund_transfer", label: "보전일시자금" },
    { value: "welfare_points", label: "복지포인트" },
    { value: "printer_rental", label: "복합기렌탈료" },
    { value: "office_maintenance", label: "사무실관리비" },
    { value: "biz_license", label: "사업자등록증" },
    { value: "server_fee", label: "서버이용료" },
    { value: "supplies_office", label: "소모(관서업무비)" },
    { value: "supplies", label: "소모품구매" },
    { value: "credit_card", label: "신용카드" },
    { value: "biz_report", label: "영업신고수수료" },
    { value: "postage", label: "우편발송" },
    { value: "withholding_tax", label: "원천세" },
    { value: "fuel_cost", label: "유류비(세차비)" },
    { value: "utility_fee", label: "인터넷·전화요금" },
    { value: "payroll", label: "임직원급여" },
    { value: "electric_bill", label: "전기료" },
    { value: "water_rental", label: "정수기렌탈료" },
    { value: "parking_fee", label: "주차비용" },
    { value: "job_training", label: "직무교육비" },
    { value: "car_installment", label: "차량할부금" },
    { value: "interview_fee", label: "채용심사비" },
    { value: "pension", label: "퇴직연금" },
  ],

  // ✅ 지출 용역사업 — value가 곧 templateCode (Intl.Collator("ko") 정렬 확인 완료)
  // ⚠️ 전 사업 확산 [4]에서 이 키는 건드리지 않음 — 이 5종은 (구) 범용 2단계 흐름
  // (DraftDocumentNew.jsx/TemplateFormFields.jsx/DocumentPreview.jsx)에 실제로
  // 하드코딩 분기가 있는 살아있는 코드라(환경/종합·환경/소독처럼 0종에서 추가한 것과
  // 다름 — 실제 서비스 데이터 0건은 "미사용 코드"가 아니라 "아직 아무도 이 카테고리로
  // 안 골랐다"는 뜻일 뿐), service_daily_wage를 빼거나 새 코드를 섞으면 (구) 흐름
  // 회귀 위험이 있음. 통합 페이지(신규)는 이 DETAIL_OPTIONS를 전혀 읽지 않고
  // serviceDraftConfig.js의 자체 TEMPLATES 배열만 쓰므로 여기 수정이 필요 없다.
  "expense_draft-용역사업": [
    { value: "service_purchase", label: "물품구매" },
    { value: "service_commission_health", label: "수수료(보건)" },
    { value: "service_commission_safety", label: "수수료(안전)" },
    { value: "fuel_cost", label: "유류비" },
    { value: "service_daily_wage", label: "일용직급여" },
  ],

  // ✅ 지출 환경/종합 — value가 곧 templateCode (통합 페이지 파일럿, 9종 확장)
  // 순서는 Intl.Collator("ko")로 9개 라벨 전체 정렬 확인 완료:
  // 계약인지세/소모품구매/유류비(세차비)/일용직급여/임직원급여/장비임차료/직무교육비/차량리스료/하도급 용역대금
  "expense_draft-환경/종합": [
    { value: "service_contract", label: "계약인지세" },
    { value: "env_total_supplies", label: "소모품구매" },
    { value: "fuel_cost", label: "유류비(세차비)" },
    { value: "env_total_daily_wage", label: "일용직급여" },
    { value: "env_total_payroll", label: "임직원급여" },
    { value: "env_total_equipment_rental", label: "장비임차료" },
    { value: "env_total_job_training", label: "직무교육비" },
    { value: "env_total_car_lease", label: "차량리스료" },
    { value: "env_total_subcontract", label: "하도급 용역대금" },
  ],

  // ✅ 지출 환경/소독 — 전 사업 확산 [2], 통합 페이지용 5종(유류비/계약인지세는
  // 기존 fuel_cost/service_contract 재사용, 나머지 3종 신규). 순서는 Intl.Collator("ko")로
  // 5개 라벨 전체 정렬 확인 완료: 계약인지세/수수료 정산/유류비(세차비)/임직원급여/차량정비비
  "expense_draft-환경/소독": [
    { value: "service_contract", label: "계약인지세" },
    { value: "env_disinfection_commission_settlement", label: "수수료 정산" },
    { value: "fuel_cost", label: "유류비(세차비)" },
    { value: "env_disinfection_payroll", label: "임직원급여" },
    { value: "env_disinfection_vehicle_maintenance", label: "차량정비비" },
  ],

  // ✅ 지출 카페인 가산점 — value가 곧 templateCode
  "expense_draft-CAFE_INN_가산": [
    { value: "gasan_maintenance", label: "관리비" },
    { value: "gasan_payroll", label: "급여지급" },
    { value: "gasan_social_insurance", label: "사회보험료" },
    { value: "gasan_goods", label: "상품구매" },
    { value: "gasan_supplies", label: "소모품구매" },
    { value: "gasan_credit_card", label: "신용카드결제" },
    { value: "gasan_internet", label: "인터넷·전화요금" },
    { value: "gasan_ingredient", label: "재료구매" },
    { value: "gasan_pos_rental", label: "포스임대료" },
  ],

  // ✅ 지출 카페인 독산점 — 가산점 복제 7종 + 독산 고유 신규 8종(명절격려품/원천세/부가세/위생교육/
  // 자판기단말기/수도/가스/전기). 순서는 Intl.Collator("ko")로 15개 전체 정렬 확인 완료:
  // 가스/급여지급/명절격려품/부가세/사회보험료/상품구매/수도/신용카드결제/원천세/위생교육/
  // 인터넷·전화요금/자판기단말기/재료구매/전기/포스임대료
  // (부가세/위생교육/수도/가스/전기는 다음 커밋에서 템플릿 정의 추가 예정 — 목록엔 미리 반영)
  "expense_draft-CAFE_INN_독산": [
    { value: "doksan_gas", label: "가스" },
    { value: "doksan_payroll", label: "급여지급" },
    { value: "doksan_holiday_gift", label: "명절격려품" },
    { value: "doksan_vat", label: "부가세" },
    { value: "doksan_social_insurance", label: "사회보험료" },
    { value: "doksan_goods", label: "상품구매" },
    { value: "doksan_water", label: "수도" },
    { value: "doksan_credit_card", label: "신용카드결제" },
    { value: "doksan_withholding_tax", label: "원천세" },
    { value: "doksan_hygiene_edu", label: "위생교육" },
    { value: "doksan_internet", label: "인터넷·전화요금" },
    { value: "doksan_vending_terminal", label: "자판기단말기" },
    { value: "doksan_ingredient", label: "재료구매" },
    { value: "doksan_electric", label: "전기" },
    { value: "doksan_pos_rental", label: "포스임대료" },
  ],

  // ✅ 지출 카페인 금나래점 — 가산/독산 복제 8종 + 독산형 신규 6종 예정(총 14종).
  // 순서는 Intl.Collator("ko")로 확인, 등록되는 대로 재정렬.
  "expense_draft-CAFE_INN_금나래": [
    { value: "geumnarae_gas", label: "가스" },
    { value: "geumnarae_payroll", label: "급여지급" },
    { value: "geumnarae_holiday_gift", label: "명절격려품" },
    { value: "geumnarae_vat", label: "부가세" },
    { value: "geumnarae_social_insurance", label: "사회보험료" },
    { value: "geumnarae_goods", label: "상품구매" },
    { value: "geumnarae_supplies", label: "소모품구매" },
    { value: "geumnarae_water", label: "수도" },
    { value: "geumnarae_credit_card", label: "신용카드결제" },
    { value: "geumnarae_withholding_tax", label: "원천세" },
    { value: "geumnarae_internet", label: "인터넷·전화요금" },
    { value: "geumnarae_ingredient", label: "재료구매" },
    { value: "geumnarae_electric", label: "전기" },
    { value: "geumnarae_pos_rental", label: "포스임대료" },
  ],

  // ✅ 지출 카페인 그린점 — 기존 카페 3개점 템플릿 합집합 17종 예정. 순서는 Intl.Collator("ko")로 확인,
  // 등록되는 대로 재정렬.
  "expense_draft-CAFE_INN_그린": [
    { value: "green_gas", label: "가스" },
    { value: "green_maintenance", label: "관리비" },
    { value: "green_payroll", label: "급여지급" },
    { value: "green_holiday_gift", label: "명절격려품" },
    { value: "green_vat", label: "부가세" },
    { value: "green_social_insurance", label: "사회보험료" },
    { value: "green_goods", label: "상품구매" },
    { value: "green_supplies", label: "소모품구매" },
    { value: "green_water", label: "수도" },
    { value: "green_credit_card", label: "신용카드결제" },
    { value: "green_withholding_tax", label: "원천세" },
    { value: "green_hygiene_edu", label: "위생교육" },
    { value: "green_internet", label: "인터넷·전화요금" },
    { value: "green_vending_terminal", label: "자판기단말기" },
    { value: "green_ingredient", label: "재료구매" },
    { value: "green_electric", label: "전기" },
    { value: "green_pos_rental", label: "포스임대료" },
  ],

};

// ✅ 지출 테스트(신기능 검증용) — 세부구분은 경영팀 템플릿 목록을 그대로 공유
DETAIL_OPTIONS["expense_draft-테스트"] = DETAIL_OPTIONS["expense_draft-경영팀"];

export default function DocumentTypeSelector({
  documentType,
  onDocumentTypeChange,
  category,
  onCategoryChange,
  detailOption,
  onDetailOptionChange,
  isDataLoaded,  // ✅ 추가
  hideDocumentType = false,  // ✅ 문서종류별 분리 페이지에서 문서 종류 버튼 행 숨김
}) {
  const categories = CATEGORY_OPTIONS[documentType] || [];

  // ✅ 현재 선택된 문서종류-카테고리에 해당하는 세부 옵션 가져오기
  const detailKey = `${documentType}-${category}`;
  const detailOptions = DETAIL_OPTIONS[detailKey] || [];

  // ✅ 세부구분 검색 필터 — 카테고리/세부구분이 바뀌면 검색어 초기화
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    setSearchTerm("");
  }, [category, detailOption]);

  const filteredDetailOptions = searchTerm
    ? detailOptions.filter((d) => d.label.includes(searchTerm))
    : detailOptions;

  return (
    <div className={styles.container}>
      {!hideDocumentType && (
        <>
          <h4 className={styles.title}>📋 문서 종류</h4>
          <div className={styles.buttonGroup}>
            {DOCUMENT_TYPES.map((type) => (
              <button
                key={type.value}
                type="button"
                className={`${styles.typeBtn} ${documentType === type.value ? styles.active : ""}`}
                onClick={() => onDocumentTypeChange(type.value)}
              >
                <span className={styles.label}>{type.label}</span>
              </button>
            ))}
          </div>
        </>
      )}

      {/* ✅ 자료를 불러왔고, 문서 종류를 선택했을 때만 카테고리 표시 */}
      {isDataLoaded && documentType && categories.length > 0 && (
        <div className={styles.categorySection}>
          <h5 className={styles.categoryTitle}>📁 카테고리</h5>
          <div className={styles.categoryGroup}>
            {categories.map((cat) => (
              <button
                key={cat.value}
                type="button"
                className={`${styles.categoryBtn} ${category === cat.value ? styles.activeCategory : ""}`}
                onClick={() => {
                  console.log("카테고리 선택:", cat.value);
                  onCategoryChange(cat.value);
                }}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* ✅ 자료를 불러왔고, 카테고리를 선택했을 때만 세부 옵션 표시 */}
      {isDataLoaded && category && detailOptions.length > 0 && (
        <div className={styles.detailSection}>
          <h5 className={styles.detailTitle}>📄 세부 구분</h5>
          <input
            type="text"
            className={styles.detailSearchInput}
            placeholder="세부구분 검색"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {filteredDetailOptions.length === 0 ? (
            <div className={styles.detailSearchEmpty}>검색 결과 없음</div>
          ) : (
            <div className={styles.detailGroup}>
              {filteredDetailOptions.map((detail) => (
                <button
                  key={detail.value}
                  type="button"
                  className={`${styles.detailBtn} ${detailOption === detail.value ? styles.activeDetail : ""}`}
                  onClick={() => {
                    console.log("세부 구분 선택:", detail.value);
                    onDetailOptionChange(detail.value);
                  }}
                >
                  {detail.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}